import React, { useContext, useEffect, useState } from 'react';
import { Genre as GenreType } from '../../types/Genre';
import { AuthenticationContext } from '../../components/authentication/AuthenticationContext';
import { Link } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import { getGenres } from '../../components/apis/music-api';
import ButtonBar from '../../components/button-bar/ButtonBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import callApi from '../../components/call-api/call-api';

const Genres = () => {
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ genres, setGenres ] = useState<GenreType[]>();
    
    useEffect(() => {
        callApi<GenreType[]>(getGenres(getAccessToken()), setGenres);
    }, [getAccessToken]);

    return (
        <>
            <ButtonBar rightButtons={[
                <Button component={Link} variant="contained" size="small" to={`/Genres/Create`}>
                    <FontAwesomeIcon fontSize="small" color="primary" icon={faPenToSquare} className="icon"/>
                    Create A Genre
                </Button>
            ]} />
            <Stack>
                <Box>
                    <Typography variant='h6'>Genres</Typography>
                    <p>{genres?.length} {(genres?.length ?? 0) === 1 ? 'genre' : 'genres'}</p>
                </Box>
            </Stack>
            {genres?.map((genre: GenreType, index: number) =>
                <Box sx={{ width: '360px', display: 'inline-flex', padding: '6px' }} key={`$genre-${index}`}>
                    <Link to={`/genres/${genre.id}`}>{genre.name}</Link>
                </Box>
            )}
        </>
    )
}

export default Genres;